import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GtAudioPlayerService {
  private dialSoundPath = '../../assets/phone-calling-1.wav';
  private dialingAudio = new Audio();
  private dialing;

  private byeSoundPath = '';
  private byeAudio = new Audio();

  private ringingSoundPath = '../../assets/ringing.wav';
  private ringingAudio = new Audio();
  private ringing;

  testing = false;

  constructor() {
    this.dialingAudio.src = this.dialSoundPath;
    this.ringingAudio.src = this.ringingSoundPath;
    this.byeAudio.src = this.byeSoundPath;
  }

  private playDialingAudio() {
    if (!this.testing) {
      this.dialingAudio.play();
    }
  }

  private playRingingAudio() {
    if (!this.testing) {
      this.ringingAudio.play();
    }
  }

  play(key: string) {
    switch (key) {
      case 'bye':
        if (!this.testing) {
          this.byeAudio.play();
        }
        break;
      case 'calling':
        this.playDialingAudio();
        if (this.dialing) {
          clearInterval(this.dialing);
        }
        this.dialing = setInterval(this.playDialingAudio.bind(this), 24000);
        break;
      case 'ringing':
        this.playRingingAudio();
        if (this.ringing) {
          clearInterval(this.ringing);
        }
        this.ringing = setInterval(this.playRingingAudio.bind(this), 25000);
        break;
    }
  }

  stop(key: string) {
    switch (key) {
      case 'bye':
        this.byeAudio.pause();
        break;
      case 'calling':
        this.dialingAudio.pause();
        if (this.dialing) {
          clearInterval(this.dialing);
        }
        break;
      case 'ringing':
        this.ringingAudio.pause();
        if (this.ringing) {
          clearInterval(this.ringing);
        }
        break;
    }
  }
}
